import styled from 'styled-components';
import FormField from '@adsk/alloy-react-form-field';
import { LinkButton } from '@adsk/alloy-react-button';
import Theme from '@adsk/alloy-react-theme';

export const StyledFormField = styled(FormField)`
  padding-top: 20px;
  width: 100%;
`;

export const FlexWrapper = styled.div`
  padding-top: 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  column-gap: 10px;
`;

export const StyledLinkButton = styled(LinkButton)`
  display: none;
  padding-top: 10px;
  align-self: start;
  &:focus {
    box-shadow: none;
  }
`;

export const StyledCountryOptionContainer = styled.div`
  width: 100%;
`;

export const StyledCountryOption = styled.div`
  font-family: ${Theme.typography.bodyMedium.fontFamily};
  font-size: ${Theme.typography.bodyMedium.fontSize};
  font-weight: ${Theme.typography.bodyMedium.fontWeight};
  display: flex;
`;

export const StyledCountryOptionFlag = styled.div`
  margin-top: 5px;
  margin-right: 8px;
`;
